module.exports = __webpack_public_path__ + "img/lezart palyazatok_gomb.2ed656db.png";